export default "__VITE_ASSET__DGC4o_c$__"